export const STANDARD_LAYOUT_PADDING_X = 3;
export const STANDARD_LAYOUT_PADDING_Y = 2;
export const CRUD_PAGE_LAYOUT_PADDING_Y = 3;
export const PAGE_BACKGROUND_COLOR = '#fbfbfc';
export const CRUD_PAGE_FORM_CONTENT_GAP = 3;
export const PAGE_COLUMN_GAP = 2;
export const PAGE_ROW_GAP = 2;
